import {NfMessage, NfMessageType} from "../NfMessage";
import {NfComponentGlobalMessage} from "../NfComponentGlobalMessage";
import type {RoomStandardDescriptionModel} from "../Models/RoomStandardDescriptionModel";

/**
 * Wiadomość, gdy wybrano jakiś standard pokoju, do service workera,
 * lub z service workera (gdy jakiś komponent się zapisze na otrzymywanie tych aktualizacji)
 */
export class SetRoomStandardChosen extends NfComponentGlobalMessage {
    public persistentMessage = true;
    // @ts-ignore
    public roomStandardChosen: RoomStandardDescriptionModel;
    public constructor(sourceComponentId: number|MessageEvent<SetRoomStandardChosen>, roomStandardChosen?:RoomStandardDescriptionModel) {
        super(NfMessageType.SetRoomStandardChosen, arguments.length > 1);
        if(NfMessage.isMessageEvent(sourceComponentId)) {
            Object.assign(this, sourceComponentId.data);
        } else {
            this.sourceComponentId = sourceComponentId;
            if(!roomStandardChosen) {
                throw Error('roomStandardChosen is required');
            }
            this.roomStandardChosen = roomStandardChosen;
        }
    }
}
NfMessage.creationCallbacks[NfMessageType.SetRoomStandardChosen] = (event) => {
    return new SetRoomStandardChosen(event);
}
